<template>
  <div :class="classes">
      <pt-page-title title="标签管理">
          <template>
           <el-button slot="before-left" type="primary" @click="created_tag" >新建标签</el-button>
           <el-button slot="before-left" type="primary" @click="related_tag" >标签关联表</el-button>
           </template>
      </pt-page-title>
      <pt-page-menu-filter :tabs="tableTags" v-model="params.type" resValue="label"></pt-page-menu-filter>
      <pt-label-table :tableLabels="tableLables" :params-data="params" ref="table">
          <el-table-column v-if="params.type=='商品标签'" label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="editLabel(scope.row)">编辑</el-button>
                  <el-button type="text" @click="deleteLabel(scope.row)">删除</el-button>
              </template>
          </el-table-column>
      </pt-label-table>
      <el-dialog :visible.sync="is_dialog" :title="dialog_title" class="creat-label-dialog" @close="closeDialog">
          <label-form v-if="is_new_tag" @close="closeDialog" :label-detail="labelDetail" :isEdit="isEdit"></label-form>
      </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import labelForm from './label-form'
import ptLabelTable from './pt-label-table/withData'
import { tableTags, goodsTableLables
//   userTableLabels, testTableLabels
} from './label-option'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-label-manage'
export default {
  name: 'pt-label-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      set: function (val) {
        this.is_new_tag = val
      },
      get: function () {
        return this.is_new_tag
      }
    }
  },
  components: {
    labelForm,
    ptLabelTable
  },
  data () {
    return {
      is_new_tag: false,
      dialog_title: '',
      tableTags: tableTags,
      selectTab: '',
      tableLables: goodsTableLables,
      params: {
      },
      labelDetail: {},
      isEdit: false
    }
  },
  watch: {
    'params.type' (val) {
    //   this.tableLables = val === '用户标签' ? userTableLabels : (val === '检测项标签' ? testTableLabels : goodsTableLables)
    }
  },
  methods: {
    getTableData (pageNumber) {
      let page = pageNumber || this.$refs.table.page
      this.$refs.table.getTableData(page)
    },
    editLabel (val) {
      this.isEdit = true
      this.labelDetail = JSON.parse(JSON.stringify(val))
      this.dialog_title = '编辑标签'
      this.is_new_tag = true
    },
    deleteLabel (val) {
      this.$confirm('您确定删除该标签吗', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(res => {
        this.$emit('deleteLabel', val.id)
      })
    },
    created_tag () {
      this.dialog_title = '新建标签'
      this.is_new_tag = true
    },
    related_tag () {
      this.$router.push('/label-manage/related-label')
    },
    closeDialog (val) {
      emptyObject(this.labelDetail)
      if (val) {
        this.getTableData(0)
      }
      this.is_dialog = false
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.creat-label-dialog{
    .el-dialog{
        padding: 10px;
        max-width: 600Px;
    }
}
</style>
